'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _momentMini = require('moment-mini');

var _momentMini2 = _interopRequireDefault(_momentMini);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: pass these in I guess..
var validDateFormats = ['YYYYMMDD', 'YYYY-M-D', 'YYYY-MMM-D', 'D-M-YYYY', 'D-MMM-YYYY', 'YYYY/M/D', 'YYYY/MMM/D', 'D/M/YYYY', 'D/MMM/YYYY', 'YYYY M D', 'YYYY MMM D', 'D M YYYY', 'D MMM YYYY', 'YYYY.M.D', 'YYYY.MMM.D', 'D.M.YYYY', 'D.MMM.YYYY'];

var validDateTimeFormats = validDateFormats.reduce(function (acc, format) {
	return [].concat((0, _toConsumableArray3.default)(acc), [format + ' h:m:s', format + ' h:m', format + ' h:m:s a', format + ' h:m a']);
}, []);

var datetimeExtension = {
	parse: function parse(value, options) {
		var formats = options.dateOnly ? validDateFormats : validDateTimeFormats;
		var result = +_momentMini2.default.utc(value, formats, true);
		return result;
	},
	format: function format(value, options) {
		var format = options.dateOnly ? 'YYYY-MM-DD' : 'YYYY-MM-DD hh:mm:ss';
		return _momentMini2.default.utc(value).format(format);
	}
};

var _default = datetimeExtension;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(validDateFormats, 'validDateFormats', 'src/validators/datetimeExtension.js');

	__REACT_HOT_LOADER__.register(validDateTimeFormats, 'validDateTimeFormats', 'src/validators/datetimeExtension.js');

	__REACT_HOT_LOADER__.register(datetimeExtension, 'datetimeExtension', 'src/validators/datetimeExtension.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/validators/datetimeExtension.js');
}();

;


// WEBPACK FOOTER //
// /Users/david/Source/react-formality/lib/validators/datetimeExtension.js